import { useOs } from '@wppopen/react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import styles from 'app/App.module.scss'
import { ScrollToTop } from 'app/ScrollToTop'
import { MainLayout } from 'layouts/MainLayout'
import { BrandDetails } from 'pages/BrandDetails/BrandDetails'
import { BrandList } from 'pages/BrandListing/BrandList'
import { Home } from 'pages/Home/Home'
import { Process } from 'pages/Process/Process'

export function AppWithOs() {
  const { osContext } = useOs()
  return <App baseUrl={osContext.baseUrl} />
}

export function App({ baseUrl }: { baseUrl?: string } = {}) {
  const pathname = window.location.pathname || '/'
  const hasBvaBase = pathname.includes('/bva')
  const basename = baseUrl ?? (hasBvaBase ? '/bva' : '/')

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
      }}
      basename={basename}
    >
      <ScrollToTop />
      <div className={styles.container}>
        <div className="min-h-[calc(100vh-var(--wpp-os-header-height))] flex flex-col relative">
          <Routes>
            <Route element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="/process" element={<Process />} />
              <Route path="/BVAFrameworks" element={<BrandList />} />
              <Route path="/:name" element={<BrandDetails />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </div>
      </div>
      <div id="react-dialog-portal" />
    </BrowserRouter>
  )
}
